import { native_players, nativePlayerInit } from './nativePlayer';
import { youtube_players, youtubePlayerInit } from './youtubePlayer';
import { vimeo_players, vimeoPlayerInit } from './vimeoPlayer';

const native_timestamps = {};
const youtube_timestamps = {};

export default function () {
  document.addEventListener('shopify:section:unload', (e) => {
    const section_id = e.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${section_id}"]`);

    section.querySelectorAll('[data-background-video]').forEach((container) => {
      const player_id = container.querySelector('[data-video-player]').id;
      const type = container.getAttribute('data-video-type');

      if (type === 'youtube') {
        if (youtube_players[player_id].getCurrentTime) {
          youtube_timestamps[player_id] = Math.floor(youtube_players[player_id].getCurrentTime());
        }

        youtube_players[player_id].destroy();
        delete youtube_players[player_id];
        return;
      }

      if (type === 'vimeo') {
        vimeo_players[player_id].destroy();
        delete vimeo_players[player_id];
        return;
      }

      if (native_players[player_id]) {
        native_timestamps[player_id] = native_players[player_id].currentTime;
        delete native_players[player_id];
        return;
      }
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    const section_id = e.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${section_id}"]`);

    section.querySelectorAll('[data-background-video]').forEach((container) => {
      const player_id = container.querySelector('[data-video-player]').id;
      const type = container.getAttribute('data-video-type');

      if (type === 'youtube') {
        const start = youtube_timestamps[player_id] || 0;
        youtubePlayerInit(container, start);
        return;
      }

      if (type === 'vimeo') {
        vimeoPlayerInit(container);
        return;
      }

      const start = native_timestamps[player_id] || 0;
      nativePlayerInit(container, start);
    });
  });
}
